// src/client/renderer/shaders/dissolve.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as DISSOLVE_VERTEX, FRAGMENT as DISSOLVE_FRAGMENT } from './dissolve.glsl';

export interface DissolveUniforms {
  /** Progress 0..1. 0=visible, 1=gone. Default: 0. */
  uProgress: THREE.IUniform<number>;
  /** Edge band width. Default: 0.05. */
  uEdgeWidth: THREE.IUniform<number>;
  /** Default: (1.0, 0.6, 0.1) hot orange. */
  uEdgeColor: THREE.IUniform<THREE.Color>;
  /** Default: (0.6, 0.6, 0.7). */
  uBaseColor: THREE.IUniform<THREE.Color>;
  /** Default: 8.0. */
  uNoiseScale: THREE.IUniform<number>;
}

export const createDissolveShader: ShaderFactory = () => {
  const uniforms: DissolveUniforms = {
    uProgress: { value: 0 },
    uEdgeWidth: { value: 0.05 },
    uEdgeColor: { value: new THREE.Color(1.0, 0.6, 0.1) },
    uBaseColor: { value: new THREE.Color(0.6, 0.6, 0.7) },
    uNoiseScale: { value: 8.0 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: DISSOLVE_VERTEX,
    fragmentShader: DISSOLVE_FRAGMENT,
    side: THREE.DoubleSide,
    transparent: true,
  });
};
